class Fullscreen {
  constructor(el = null) {
    this.el = el || global.document.documentElement;

    this.request = this.request.bind(this);
    this.exit = this.exit.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  request() {
    if (this.el.requestFullscreen) {
      this.el.requestFullscreen();
    } else if (this.el.mozRequestFullScreen) {
      this.el.mozRequestFullScreen();
    } else if (this.el.webkitRequestFullscreen) {
      this.el.webkitRequestFullscreen();
    } else if (this.el.msRequestFullscreen) {
      this.el.msRequestFullscreen();
    }
  }

  exit() {
    if (global.document.exitFullscreen) {
      global.document.exitFullscreen();
    } else if (global.document.mozCancelFullScreen) {
      global.document.mozCancelFullScreen();
    } else if (global.document.mozCancelFullscreen) {
      global.document.mozCancelFullScreen();
    } else if (global.document.webkitExitFullscreen) {
      global.document.webkitExitFullscreen();
    } else if (global.document.msExitFullscreen) {
      global.document.msExitFullscreen();
    }
  }

  toggle() {
    if (this.fullscreenElement) {
      this.exit();
    } else {
      this.request();
    }
  }

  get fullscreenElement() {
    return (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.webkitCurrentFullScreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement ||
      null
    );
  }
}

export default Fullscreen;
